var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineUnfavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.35 10.09h0a.73.73 0 00-1 .33l-3 5.89-5.72.56a.76.76 0 00-.45.21.72.72 0 000 1l4.72 4.67-1.75 6.35a.7.7 0 000 .51s0 0 0 0a.72.72 0 001 .28L20 27.05l5.83 2.87a.75.75 0 00.51.06h0a.73.73 0 00.5-.89l-1.74-6.34 4.71-4.67a.76.76 0 00.21-.45.72.72 0 00-.66-.77l-5.72-.57-3-5.89a.75.75 0 00-.29-.31z",
    fill: "#575757",
    stroke: "#575757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    "data-name": "icon unfavourite"
  })));
}
export default SvgStreamlineUnfavourite;